import createComponent from 'styles/fela/createComponent';

export const App = createComponent(({ fixedHeight }) => ({
  display: 'flex',
  flexDirection: 'column',
  extend: [
    {
      condition: fixedHeight,
      style: {
        height: '100vh',
      },
    },
  ],
}), 'div', ['fixedHeight']);

App.displayName = 'App';

export const Main = createComponent(({ theme, fixedHeight }) => ({
  backgroundColor: theme.color.page,
  color: theme.color.primary,
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: `calc(100vh - ${theme.header.height})`,
  width: '100%',
  extend: [
    {
      condition: fixedHeight,
      style: {
        minHeight: 'auto',
      },
    },
  ],
}), 'main', ['fixedHeight']);

export const Content = createComponent(() => ({
  flexGrow: 1,

  display: 'flex',
  alignItems: 'stretch',
  flexWrap: 'wrap',
  ':focus': {
    outline: 'none',
  },
}));

export const SkipLink = createComponent(({ theme }) => ({
  position: 'absolute',
  top: '0',
  left: '0',
  transform: 'translateY(-110%)',
  zIndex: theme.zIndex.modal + 10,
  minWidth: '10rem',
  padding: theme.margin.medium,
  backgroundColor: theme.color.page,
  color: theme.color.primary,
  textAlign: 'center',
  textDecoration: 'none',
  ':focus': {
    transform: 'translateY(0)',
    outline: `2px solid ${theme.color.primary}`,
  },
}), 'a');
